import { ajaxActions } from '../AjaxActions';

export const findUnresolvablePlaceholders = (subject, message) =>
  ajaxActions
    .post(`${process.env.REACT_APP_PLACEHOLDER_SERVICE_URL}/replace/messages`, {
      subject,
      message,
    })
    .then((resp) => resp);
